export enum RequiredActionKey {
    MesSyncFailed = 'MesSyncFailed',
    DispositionRequired = 'DispositionRequired',
}

export enum RequiredActionOwnerType {
    Customer = 'Customer',
    CustomerOrder = 'CustomerOrder',
    ProductionOrder = 'ProductionOrder',
    Part = 'Part',
    StockReservation = 'StockReservation',
}

export enum RequiredActionState {
    Open = 'Open',
    Resolved = 'Resolved',
}

export interface IRequiredAction {
    id: string;
    version?: string | null;
    actionKey: RequiredActionKey | string;
    ownerType: RequiredActionOwnerType | string;
    ownerId: string;
    ownerDisplayName: string;
    state: RequiredActionState | string;
    createdAt: string;
    createdBy?: string | null;
    resolvedAt?: string | null;
    resolvedBy?: string | null;
    comment?: string | null;
    dueDate?: string | null;
}

export interface IRequiredActionListResponse {
    value: IRequiredAction[];
    '@odata.count'?: number | null;
    '@odata.context'?: string | null;
}
